/**
 * @generated SignedSource<<853c0767d2f726e05ef3516e8303bcb2>>
 * @relayHash fc01dffdabd110ab2499fb61ac9a8d6a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/545.0.0-2026-02-05T14:54:35.766Z/pdpRespMarketplacePrimaryRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type MlType = "ALL_ITEMS" | "ALL_ITEMS_RERANKED" | "ONLY_DEALER_ITEMS" | "REMOVE_DEALER_ITEMS" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type pdpRespMarketplacePrimaryRootQuery$variables = {
  afterDisplay?: boolean | null;
  afterDisplayAndBtSsr?: boolean | null;
  fetchPdp?: boolean | null;
  fetchUser?: boolean | null;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  forcedCurrency?: Currency | null;
  isEstimateSimilarSoldVariant?: boolean | null;
  isInteractivePdpChat?: boolean | null;
  isMultiSku?: boolean | null;
  isPDPDesktopAggregationVariant?: boolean | null;
  isTrade?: boolean | null;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  mlType?: MlType | null;
  personalizationId?: string | null;
  priceBookName?: string | null;
  similarItemsCount: number;
  userCountryCode?: string | null;
  userId?: string | null;
  userIds: ReadonlyArray<string | null>;
  userZipCode?: string | null;
};
export type pdpRespMarketplacePrimaryRootQuery$data = {
  readonly viewer: {
    readonly itemRead: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_item" | "PersonalizedCollectionsContext_item" | "findPdpItemReadError_itemRead" | "handlePdpStatuses_item">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_viewer" | "PdpRespMarketplaceLayoutPrimary_viewer">;
  };
};
export type pdpRespMarketplacePrimaryRootQuery = {
  response: pdpRespMarketplacePrimaryRootQuery$data;
  variables: pdpRespMarketplacePrimaryRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplay"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplayAndBtSsr"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchPdp"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v5 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forcedCurrency"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isEstimateSimilarSoldVariant"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isInteractivePdpChat"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isMultiSku"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPDPDesktopAggregationVariant"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemIds"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mlType"
},
v15 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v16 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "similarItemsCount"
},
v18 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v19 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v21 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v22 = {
  "alias": "isPdpUrlTranslationEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "translatedPdpUrls"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
},
v23 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v24 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v25 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v26 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "currency",
      "variableName": "forcedCurrency"
    },
    (v24/*: any*/),
    (v25/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "microdata",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpURL",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ogTitle",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceAmount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceCurrency",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "LanguageAnnotations",
  "kind": "LinkedField",
  "name": "languageAnnotations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hrefLang",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webPath",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v38 = [
  (v37/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageVersionType",
      "kind": "LinkedField",
      "name": "type",
      "plural": false,
      "selections": (v38/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPriceUponRequest",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAuctionEnabled",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingListed",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingNotListed",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingUnlisted",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingMigrated",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNew",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWip",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSold",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternal",
  "storageKey": null
},
v54 = [
  {
    "kind": "Literal",
    "name": "metricTypes",
    "value": [
      "ITEM_LISTING_VIEWS"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeRange",
    "value": "LAST_6_MONTHS"
  }
],
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v56 = [
  (v55/*: any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivateVisibilityType",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrivateListing",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirectType",
  "kind": "LinkedField",
  "name": "redirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageType",
      "storageKey": null
    }
  ],
  "type": "ItemReadError",
  "abstractKey": null
},
v62 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v63 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v64 = [
  (v62/*: any*/),
  (v63/*: any*/)
],
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v67 = [
  (v65/*: any*/),
  (v66/*: any*/)
],
v68 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v69 = [
  (v68/*: any*/)
],
v70 = {
  "alias": "monthsSinceStartDate",
  "args": [
    {
      "kind": "Literal",
      "name": "unit",
      "value": "MONTH"
    }
  ],
  "kind": "ScalarField",
  "name": "timeSinceStartDate",
  "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerProfile",
  "kind": "LinkedField",
  "name": "sellerProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = {
  "alias": "isRewardsTier2",
  "args": [
    {
      "kind": "Literal",
      "name": "listName",
      "value": "SELLER_REWARDS_2"
    }
  ],
  "kind": "ScalarField",
  "name": "isAnchorListMember",
  "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGoldTier",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPlatinumTier",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerTierDataNotFound",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerTiers",
  "kind": "LinkedField",
  "name": "sellerTiers",
  "plural": false,
  "selections": [
    (v73/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/)
  ],
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatedOrderFeedbackType",
      "kind": "LinkedField",
      "name": "aggregatedFeedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackQuestionType",
          "kind": "LinkedField",
          "name": "overallExperience",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mean",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicNoteTotalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDistinguished",
  "storageKey": null
},
v79 = [
  (v63/*: any*/)
],
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v81 = {
  "kind": "Literal",
  "name": "page",
  "value": "pdp"
},
v82 = [
  (v68/*: any*/),
  (v81/*: any*/)
],
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAcceptOffer",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPurchase",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMakeOffer",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showRequestPrice",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showFollowCategory",
  "storageKey": null
},
v88 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      (v85/*: any*/)
    ],
    "storageKey": null
  }
],
v89 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v90 = {
  "alias": null,
  "args": (v89/*: any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v92 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v93 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v94 = [
  (v68/*: any*/),
  (v92/*: any*/),
  (v93/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/)
],
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v97 = [
  (v95/*: any*/),
  (v96/*: any*/)
],
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "originalConvertedAmountList",
  "plural": true,
  "selections": (v97/*: any*/),
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v97/*: any*/),
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "privateOfferConvertedAmountList",
  "plural": true,
  "selections": (v97/*: any*/),
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantityDisplay",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentageOff",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "privateOfferPercentageOff",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPriceLabel",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerExpirationDate",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVatIncluded",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceBookName",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": (v94/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v98/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v101/*: any*/),
    (v102/*: any*/),
    (v103/*: any*/),
    (v104/*: any*/),
    (v105/*: any*/),
    (v106/*: any*/),
    (v107/*: any*/),
    (v108/*: any*/),
    (v109/*: any*/)
  ],
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": (v94/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v104/*: any*/),
    (v105/*: any*/),
    (v98/*: any*/),
    (v99/*: any*/),
    (v102/*: any*/),
    (v100/*: any*/),
    (v103/*: any*/),
    (v107/*: any*/),
    (v101/*: any*/),
    (v108/*: any*/),
    (v109/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saleEndDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v118 = [
  (v81/*: any*/)
],
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reserveMet",
  "storageKey": null
},
v121 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v122 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v55/*: any*/)
],
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPath",
  "storageKey": null
},
v126 = [
  (v41/*: any*/),
  (v66/*: any*/)
],
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnlimitedQuantity",
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": (v94/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v106/*: any*/)
  ],
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "concreteType": "Hold",
  "kind": "LinkedField",
  "name": "activeHold",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTimeToExpire",
      "storageKey": null
    },
    (v66/*: any*/)
  ],
  "storageKey": null
},
v132 = {
  "alias": "priceType",
  "args": [
    {
      "kind": "Literal",
      "name": "buyerId",
      "value": ""
    },
    (v92/*: any*/),
    {
      "kind": "Literal",
      "name": "isTrade",
      "value": false
    }
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v104/*: any*/)
  ],
  "storageKey": "displayPrice(buyerId:\"\",catchNonFatalErrors:false,isTrade:false)"
},
v133 = {
  "alias": null,
  "args": (v69/*: any*/),
  "concreteType": "Transaction",
  "kind": "LinkedField",
  "name": "lastActiveTransaction",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedCheckout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionType",
      "storageKey": null
    },
    (v66/*: any*/)
  ],
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "USD",
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPricing",
  "kind": "LinkedField",
  "name": "pricing",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            (v134/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "GBP",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "EUR",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "CAD",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "AUD",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "CHF",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "MXN",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "NOK",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "SEK",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "DKK",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": [
    (v25/*: any*/),
    (v63/*: any*/),
    {
      "kind": "Variable",
      "name": "userZipCode",
      "variableName": "userZipCode"
    }
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v138 = {
  "alias": "makeOfferVpvParams",
  "args": [
    {
      "kind": "Literal",
      "name": "excludedPurchaseStatuses",
      "value": [
        "RET",
        "CUST"
      ]
    },
    (v63/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v139 = [
  (v99/*: any*/),
  (v108/*: any*/)
],
v140 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v142 = [
  {
    "kind": "Literal",
    "name": "shortTitles",
    "value": true
  }
],
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabType",
  "storageKey": null
},
v144 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabTitle",
  "storageKey": null
},
v145 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentHeader",
  "storageKey": null
},
v146 = [
  (v115/*: any*/),
  (v116/*: any*/)
],
v147 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentBodyText",
  "storageKey": null
},
v148 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "browseLink",
  "plural": false,
  "selections": (v146/*: any*/),
  "storageKey": null
},
v149 = {
  "kind": "InlineFragment",
  "selections": [
    (v66/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v150 = [
  {
    "kind": "Literal",
    "name": "fullCountryName",
    "value": true
  }
],
v151 = {
  "kind": "Literal",
  "name": "feedbackSellerPublicNoteHasText",
  "value": true
},
v152 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v153 = {
  "kind": "Literal",
  "name": "minimumReviewRating",
  "value": 4
},
v154 = [
  (v60/*: any*/),
  (v66/*: any*/)
],
v155 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerOrderQuantity",
  "storageKey": null
},
v156 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v157 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v156/*: any*/)
  ],
  "storageKey": null
},
v158 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCustomizable",
  "storageKey": null
},
v159 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v126/*: any*/),
  "storageKey": null
},
v160 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "customizable",
  "plural": true,
  "selections": [
    (v159/*: any*/),
    (v114/*: any*/)
  ],
  "storageKey": null
},
v161 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "ringResizable",
  "plural": true,
  "selections": [
    (v159/*: any*/)
  ],
  "storageKey": null
},
v162 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "leadTime",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        (v66/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v163 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seoDescription",
  "storageKey": null
},
v164 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v165 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delimiter",
  "storageKey": null
},
v166 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailDisplayName",
  "storageKey": null
},
v167 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPdpDetailValueInterface"
},
v168 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDetails",
  "storageKey": null
},
v169 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RingSizeDetail",
      "kind": "LinkedField",
      "name": "ringSizes",
      "plural": true,
      "selections": (v122/*: any*/),
      "storageKey": null
    }
  ],
  "type": "PdpDetailRingSize",
  "abstractKey": null
},
v170 = {
  "alias": null,
  "args": null,
  "concreteType": "PdpDetail",
  "kind": "LinkedField",
  "name": "pdpDetailsDisplay",
  "plural": true,
  "selections": [
    (v164/*: any*/),
    (v165/*: any*/),
    (v166/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "detailValues",
      "plural": true,
      "selections": [
        (v60/*: any*/),
        (v167/*: any*/),
        (v164/*: any*/),
        (v51/*: any*/),
        (v113/*: any*/),
        (v168/*: any*/),
        (v91/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": [
                (v99/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "PdpDetailVersionsValue",
          "abstractKey": null
        },
        (v169/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v171 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAvailable",
  "storageKey": null
},
v172 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
],
v173 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        (v25/*: any*/)
      ],
      "concreteType": "InlineCtaCopy",
      "kind": "LinkedField",
      "name": "returnPolicySection",
      "plural": false,
      "selections": (v172/*: any*/),
      "storageKey": null
    }
  ]
},
v174 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "customizableDetailReturnCopy",
  "plural": false,
  "selections": (v172/*: any*/),
  "storageKey": null
},
v175 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "returnPolicySectionHeader",
  "plural": false,
  "selections": (v172/*: any*/),
  "storageKey": null
},
v176 = [
  (v68/*: any*/),
  (v93/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/)
],
v177 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v96/*: any*/),
    (v95/*: any*/)
  ],
  "storageKey": null
},
v178 = [
  (v177/*: any*/)
],
v179 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "medianAmount",
  "plural": false,
  "selections": (v178/*: any*/),
  "storageKey": null
},
v180 = [
  (v96/*: any*/)
],
v181 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": (v180/*: any*/),
  "storageKey": null
},
v182 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "minAmount",
  "plural": false,
  "selections": (v180/*: any*/),
  "storageKey": null
},
v183 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "maxAmount",
  "plural": false,
  "selections": (v180/*: any*/),
  "storageKey": null
},
v184 = {
  "alias": null,
  "args": (v79/*: any*/),
  "concreteType": "ReturnPolicy",
  "kind": "LinkedField",
  "name": "returnPolicy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeEuReturns",
          "value": true
        },
        (v25/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "returnDays",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v185 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v186 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "itemThumbnail",
          "args": (v185/*: any*/),
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"thumb\")"
        }
      ]
    }
  ]
},
v187 = {
  "alias": null,
  "args": (v69/*: any*/),
  "kind": "ScalarField",
  "name": "hasActiveHoldForBuyer",
  "storageKey": null
},
v188 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v187/*: any*/)
  ]
},
v189 = {
  "alias": null,
  "args": null,
  "concreteType": "MCAnalytics",
  "kind": "LinkedField",
  "name": "analytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalyticsMetrics",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCMetricResponseTime",
          "kind": "LinkedField",
          "name": "responseTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summaryCopy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v190 = {
  "alias": null,
  "args": (v82/*: any*/),
  "concreteType": "ItemDisplayInfo",
  "kind": "LinkedField",
  "name": "displayInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHoldRequest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v191 = [
  (v177/*: any*/),
  (v96/*: any*/)
],
v192 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v193 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelrySeller",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v194 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "leadTimeDisplay",
  "storageKey": null
},
v195 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanceled",
  "storageKey": null
},
v196 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExpired",
  "storageKey": null
},
v197 = [
  (v37/*: any*/),
  (v66/*: any*/)
],
v198 = [
  (v96/*: any*/),
  (v95/*: any*/),
  (v99/*: any*/)
],
v199 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v200 = [
  (v199/*: any*/)
],
v201 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "countryCode",
      "variableName": "userCountryCode"
    }
  ],
  "kind": "ScalarField",
  "name": "isGdprApplicable",
  "storageKey": null
},
v202 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingOptInMessage",
  "storageKey": null
},
v203 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "similarSoldItemsResults",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 0
        },
        (v62/*: any*/)
      ],
      "concreteType": "SimilarSoldItemsConnection",
      "kind": "LinkedField",
      "name": "similarSoldItems",
      "plural": false,
      "selections": (v200/*: any*/),
      "storageKey": null
    }
  ]
},
v204 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v205 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v206 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    (v95/*: any*/)
  ],
  "storageKey": null
},
v207 = [
  (v68/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
],
v208 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v209 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v210 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v203/*: any*/)
      ]
    }
  ]
},
v211 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v212 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canShowSellerName",
  "storageKey": null
},
v213 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeFirmRewards",
  "kind": "LinkedField",
  "name": "rewards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParentProgram",
      "kind": "LinkedField",
      "name": "currentProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "programInfo",
          "plural": false,
          "selections": (v67/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "ENHANCED_BUYER_PROTECTION"
            }
          ],
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "childPrograms",
          "plural": true,
          "selections": (v67/*: any*/),
          "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v214 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v215 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PdpHeadBuilder_viewer",
            "selections": [
              (v22/*: any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespMarketplaceLayoutPrimary_viewer"
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PersonalizedCollectionsContext_item"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "PdpHeadBuilder_item",
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "pdpMetaItems",
                        "kind": "LinkedField",
                        "name": "pdpMeta",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "getLanguageAnnotations_pdpMetaItems",
                            "selections": [
                              (v35/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v40/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": [
                      {
                        "kind": "RootArgument",
                        "name": "forcedCurrency"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "priceBookName"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "userCountryCode"
                      }
                    ]
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "handlePdpStatuses_item",
                    "selections": [
                      (v30/*: any*/),
                      (v41/*: any*/),
                      (v28/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": "relevantAuctionLotRedirect",
                        "args": null,
                        "concreteType": "AuctionLot",
                        "kind": "LinkedField",
                        "name": "relevantAuctionLot",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v52/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v54/*: any*/),
                        "concreteType": "MetricDetailType",
                        "kind": "LinkedField",
                        "name": "metrics",
                        "plural": true,
                        "selections": (v56/*: any*/),
                        "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                      },
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "findPdpItemReadError_itemRead",
                "selections": [
                  (v60/*: any*/),
                  (v61/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v20/*: any*/),
      (v19/*: any*/),
      (v21/*: any*/),
      (v11/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v16/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v18/*: any*/),
      (v0/*: any*/),
      (v15/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v14/*: any*/),
      (v17/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          {
            "alias": null,
            "args": (v64/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v67/*: any*/),
            "storageKey": null
          },
          {
            "alias": "videoUploadToolsFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "videoUploadTools"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"videoUploadTools\")"
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v60/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isItemReadType"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "itemIsOnHold",
                    "args": (v69/*: any*/),
                    "kind": "ScalarField",
                    "name": "isOnHold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v66/*: any*/),
                      (v53/*: any*/),
                      (v41/*: any*/),
                      (v52/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v76/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              (v77/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v78/*: any*/),
                          {
                            "alias": null,
                            "args": (v79/*: any*/),
                            "concreteType": "BuyerOrderReviewType",
                            "kind": "LinkedField",
                            "name": "buyerOrderReview",
                            "plural": false,
                            "selections": [
                              (v80/*: any*/),
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "image",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pdpUrl",
                                "storageKey": null
                              },
                              (v60/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v82/*: any*/),
                    "concreteType": "ItemDisplayInfo",
                    "kind": "LinkedField",
                    "name": "displayInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "kind": "LinkedField",
                        "name": "ctas",
                        "plural": false,
                        "selections": [
                          (v83/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showSale",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showNet",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showUnavailable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "afterDisplayAndBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "kind": "LinkedField",
                            "name": "ctas",
                            "plural": false,
                            "selections": [
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v87/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "isPDPDesktopAggregationVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v88/*: any*/)
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "skus",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      (v66/*: any*/),
                      (v90/*: any*/),
                      (v91/*: any*/),
                      {
                        "condition": "isPDPDesktopAggregationVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "condition": "isMultiSku",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v110/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "isMultiSku",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v111/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/),
                  (v112/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemClassification",
                    "kind": "LinkedField",
                    "name": "classification",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creationDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCategory",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "precedence",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              (v51/*: any*/),
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attribution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v113/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v66/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v114/*: any*/),
                      (v115/*: any*/),
                      (v116/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPublishedPrivate",
                    "storageKey": null
                  },
                  (v42/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vertical",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      (v117/*: any*/),
                      (v66/*: any*/),
                      (v39/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*: any*/),
                  (v90/*: any*/),
                  {
                    "alias": null,
                    "args": (v118/*: any*/),
                    "concreteType": "AuctionLot",
                    "kind": "LinkedField",
                    "name": "relevantAuctionLot",
                    "plural": false,
                    "selections": [
                      (v119/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      (v66/*: any*/)
                    ],
                    "storageKey": "relevantAuctionLot(page:\"pdp\")"
                  },
                  {
                    "alias": null,
                    "args": (v118/*: any*/),
                    "concreteType": "AuctionSolution",
                    "kind": "LinkedField",
                    "name": "relevantAuctionSolution",
                    "plural": false,
                    "selections": [
                      (v120/*: any*/),
                      (v66/*: any*/)
                    ],
                    "storageKey": "relevantAuctionSolution(page:\"pdp\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoVimeo",
                    "kind": "LinkedField",
                    "name": "videoVimeo",
                    "plural": false,
                    "selections": [
                      (v119/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vimeoId",
                        "storageKey": null
                      },
                      (v60/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includePlayButton",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "pad",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w100h75"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                      },
                      {
                        "alias": null,
                        "args": (v89/*: any*/),
                        "concreteType": "VideoVimeoFile",
                        "kind": "LinkedField",
                        "name": "fileByVideoSize",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "link",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "fileByVideoSize(size:\"small\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemReviewDocumentList",
                    "kind": "LinkedField",
                    "name": "reviews",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemReview",
                        "kind": "LinkedField",
                        "name": "videoReview",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMultiSku",
                    "storageKey": null
                  },
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemMeasurement",
                    "kind": "LinkedField",
                    "name": "measurement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "IN"
                          }
                        ],
                        "concreteType": "ItemConvertedMeasurementsType",
                        "kind": "LinkedField",
                        "name": "convertedMeasurements",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "width",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "convertedMeasurements(unit:\"IN\")"
                      },
                      {
                        "alias": "widthDimensions",
                        "args": [
                          (v121/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "width"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v122/*: any*/),
                        "storageKey": "display(addLabel:false,fields:[\"width\"])"
                      },
                      {
                        "alias": "heightDimensions",
                        "args": [
                          (v121/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "height"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v122/*: any*/),
                        "storageKey": "display(addLabel:false,fields:[\"height\"])"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "sortedPhotos",
                    "plural": true,
                    "selections": [
                      (v60/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "kind": "LinkedField",
                        "name": "imageSkuXrefs",
                        "plural": true,
                        "selections": [
                          (v91/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v123/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alt",
                        "storageKey": null
                      },
                      (v117/*: any*/),
                      (v66/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "viewInRoomPhotos",
                    "kind": "LinkedField",
                    "name": "viewInRoomPhotos",
                    "plural": true,
                    "selections": [
                      (v60/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "src",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "credits",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosCenterPosition",
                        "kind": "LinkedField",
                        "name": "centerPosition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "top",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "left",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosComparatorWidth",
                        "kind": "LinkedField",
                        "name": "comparatorWidth",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pixel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inches",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v58/*: any*/),
                  (v49/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUnpurchasable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contemporaryTrackingString",
                    "storageKey": null
                  },
                  (v51/*: any*/),
                  (v124/*: any*/),
                  (v125/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isComplete",
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "pdpMetaItems",
                    "kind": "LinkedField",
                    "name": "pdpMeta",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v40/*: any*/),
                  {
                    "alias": "relevantAuctionLotRedirect",
                    "args": null,
                    "concreteType": "AuctionLot",
                    "kind": "LinkedField",
                    "name": "relevantAuctionLot",
                    "plural": false,
                    "selections": (v126/*: any*/),
                    "storageKey": null
                  },
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v50/*: any*/),
                  {
                    "alias": null,
                    "args": (v54/*: any*/),
                    "concreteType": "MetricDetailType",
                    "kind": "LinkedField",
                    "name": "metrics",
                    "plural": true,
                    "selections": [
                      (v55/*: any*/),
                      (v66/*: any*/)
                    ],
                    "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                  },
                  (v57/*: any*/),
                  (v59/*: any*/),
                  {
                    "condition": "afterDisplayAndBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v127/*: any*/),
                          (v128/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SkuQuantityOption",
                            "kind": "LinkedField",
                            "name": "quantitySelectOptions",
                            "plural": true,
                            "selections": [
                              (v129/*: any*/),
                              (v55/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "setSize",
                            "storageKey": null
                          },
                          {
                            "condition": "isMultiSku",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v130/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      (v131/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AttributeValue",
                            "kind": "LinkedField",
                            "name": "framingStatus",
                            "plural": true,
                            "selections": (v56/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v111/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SaveSearchDataType",
                        "kind": "LinkedField",
                        "name": "saveSearchData",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "page",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v132/*: any*/),
                      (v133/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v135/*: any*/),
                      (v136/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v137/*: any*/),
                          (v138/*: any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplayAndBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "displayPriceDefault",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "DEFAULT"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v139/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"DEFAULT\")"
                              },
                              {
                                "alias": "displayPriceAU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "AU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v139/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"AU\")"
                              },
                              {
                                "alias": "displayPriceEU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "EU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v139/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"EU\")"
                              },
                              {
                                "alias": "displayPriceGB",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "GB"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v139/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"GB\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v130/*: any*/)
                        ]
                      },
                      {
                        "condition": "isMultiSku",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v82/*: any*/),
                                "concreteType": "SkuDisplayInfo",
                                "kind": "LinkedField",
                                "name": "displayInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CTADisplay",
                                    "kind": "LinkedField",
                                    "name": "ctas",
                                    "plural": false,
                                    "selections": [
                                      (v84/*: any*/),
                                      (v85/*: any*/),
                                      (v86/*: any*/),
                                      (v87/*: any*/),
                                      (v83/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isPDPDesktopAggregationVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "condition": "isMultiSku",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SkuRingSizeDisplay",
                                "kind": "LinkedField",
                                "name": "ringSizeDisplay",
                                "plural": false,
                                "selections": [
                                  (v140/*: any*/),
                                  (v141/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "storyTelling",
                        "args": (v142/*: any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v143/*: any*/),
                              (v144/*: any*/),
                              (v145/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "kind": "LinkedField",
                                "name": "contentCreatorAttribution",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "creatorName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LinkData",
                                    "kind": "LinkedField",
                                    "name": "creatorBrowseUrl",
                                    "plural": false,
                                    "selections": (v146/*: any*/),
                                    "storageKey": null
                                  },
                                  (v60/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v147/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mainImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mainVideo",
                                "storageKey": null
                              },
                              (v148/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "smallImage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v72/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorefrontProfile",
                            "kind": "LinkedField",
                            "name": "liveStorefrontProfile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "aboutUsUnbranded",
                                "storageKey": null
                              },
                              (v66/*: any*/),
                              {
                                "alias": "headshots",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "photoType",
                                    "value": "DEALER_STOREFRONT_HEADSHOT"
                                  }
                                ],
                                "concreteType": "Photo",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v119/*: any*/),
                                  (v115/*: any*/),
                                  (v66/*: any*/)
                                ],
                                "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaAlbum",
                                "kind": "LinkedField",
                                "name": "galleryAlbum",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MediaElement",
                                    "kind": "LinkedField",
                                    "name": "mediaList",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "element",
                                        "plural": false,
                                        "selections": [
                                          (v60/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v115/*: any*/)
                                            ],
                                            "type": "Photo",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "Video",
                                            "abstractKey": null
                                          },
                                          (v149/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "establishmentYear",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              (v77/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v126/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v70/*: any*/),
                          (v71/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "shippingAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "displayFullCityStateCountry",
                                "args": (v150/*: any*/),
                                "kind": "ScalarField",
                                "name": "displayCityStateCountry",
                                "storageKey": "displayCityStateCountry(fullCountryName:true)"
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v76/*: any*/),
                          {
                            "alias": "dealerDetailsHeaderFeedback",
                            "args": [
                              (v151/*: any*/),
                              (v152/*: any*/),
                              (v153/*: any*/)
                            ],
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v154/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4)"
                          },
                          (v78/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "agreementStart",
                            "storageKey": null
                          },
                          (v155/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MCAnalytics",
                            "kind": "LinkedField",
                            "name": "analytics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MCAnalyticsMetrics",
                                "kind": "LinkedField",
                                "name": "metrics",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MCMetricResponseTime",
                                    "kind": "LinkedField",
                                    "name": "responseTime",
                                    "plural": false,
                                    "selections": (v56/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeAssociation",
                            "kind": "LinkedField",
                            "name": "tradeAssociations",
                            "plural": true,
                            "selections": [
                              (v41/*: any*/),
                              (v113/*: any*/),
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "dealerDetailsOrderFeedbackPdp",
                                "args": [
                                  (v151/*: any*/),
                                  (v152/*: any*/),
                                  (v153/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "sortBy",
                                    "value": "sellerExperienceDesc"
                                  }
                                ],
                                "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                                "kind": "LinkedField",
                                "name": "orderFeedbackPdp",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderFeedbackPdp",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "completedDate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "kind": "LinkedField",
                                            "name": "transaction",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "buyer",
                                                "plural": false,
                                                "selections": [
                                                  (v157/*: any*/),
                                                  (v66/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Shipment",
                                                "kind": "LinkedField",
                                                "name": "shipment",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "kind": "LinkedField",
                                                    "name": "shippingAddress",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "displayState",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "displayCountry",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "country",
                                                        "storageKey": null
                                                      },
                                                      (v66/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v66/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v66/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "overallExperience",
                                            "plural": false,
                                            "selections": [
                                              (v60/*: any*/),
                                              (v80/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "publicNote",
                                            "plural": false,
                                            "selections": [
                                              (v60/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "freetext",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v66/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      (v158/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v160/*: any*/),
                          (v161/*: any*/),
                          (v162/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v163/*: any*/),
                      (v170/*: any*/),
                      (v171/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasShipmentQuotes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v79/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accept",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReturnPolicyCopy",
                            "kind": "LinkedField",
                            "name": "buyerCopy",
                            "plural": false,
                            "selections": [
                              (v173/*: any*/),
                              (v174/*: any*/),
                              (v175/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "itemAddress",
                            "args": (v150/*: any*/),
                            "kind": "ScalarField",
                            "name": "displayCityStateCountry",
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v132/*: any*/),
                      {
                        "alias": null,
                        "args": (v176/*: any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v178/*: any*/),
                            "storageKey": null
                          },
                          (v179/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v178/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v178/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v176/*: any*/),
                            "concreteType": "PricingGuidance",
                            "kind": "LinkedField",
                            "name": "pricingGuidance",
                            "plural": false,
                            "selections": [
                              (v181/*: any*/),
                              (v182/*: any*/),
                              (v183/*: any*/),
                              (v129/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v184/*: any*/)
                        ]
                      },
                      (v186/*: any*/),
                      (v188/*: any*/),
                      {
                        "condition": "fetchPdp",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Phone",
                                "kind": "LinkedField",
                                "name": "trackedPhone",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "phoneNumber",
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v189/*: any*/),
                              (v60/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "dealerDetailsDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v88/*: any*/),
                            "storageKey": null
                          },
                          {
                            "condition": "fetchUser",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v190/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v176/*: any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v191/*: any*/),
                            "storageKey": null
                          },
                          (v179/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v191/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v191/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v162/*: any*/),
                          (v160/*: any*/),
                          (v161/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v79/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReturnPolicyCopy",
                            "kind": "LinkedField",
                            "name": "buyerCopy",
                            "plural": false,
                            "selections": [
                              (v175/*: any*/),
                              (v173/*: any*/),
                              (v174/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v192/*: any*/),
                      (v163/*: any*/),
                      (v158/*: any*/),
                      (v170/*: any*/),
                      (v171/*: any*/),
                      (v193/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelry",
                        "storageKey": null
                      },
                      (v132/*: any*/),
                      (v194/*: any*/),
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v69/*: any*/),
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "lastTransaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "checkoutDate",
                                "storageKey": null
                              },
                              (v195/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "mostRecentOffer",
                                "plural": false,
                                "selections": [
                                  (v196/*: any*/),
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v187/*: any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v184/*: any*/),
                          {
                            "alias": null,
                            "args": (v69/*: any*/),
                            "kind": "ScalarField",
                            "name": "hasRequestedHoldForBuyer",
                            "storageKey": null
                          },
                          (v190/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v136/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "kind": "LinkedField",
                        "name": "variableAttributes",
                        "plural": true,
                        "selections": [
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "kind": "LinkedField",
                            "name": "variableAttributeData",
                            "plural": false,
                            "selections": [
                              (v113/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "kind": "LinkedField",
                                "name": "primaryAttribute",
                                "plural": false,
                                "selections": (v197/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "kind": "LinkedField",
                                "name": "swatchSort",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortOrder",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "kind": "LinkedField",
                                    "name": "swatch",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v113/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "ringSize",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SwatchAttributeByNameProperties",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                              (v141/*: any*/),
                                              (v140/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "material",
                                        "plural": false,
                                        "selections": (v38/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v37/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentName",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "buyerSideSkus",
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": (v185/*: any*/),
                            "kind": "ScalarField",
                            "name": "firstPhotoWebPath",
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidePrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "retailPrice",
                                "plural": false,
                                "selections": (v198/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "netPrice",
                                "plural": false,
                                "selections": (v198/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "salePrice",
                                "plural": false,
                                "selections": (v198/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v127/*: any*/),
                          (v128/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "PDP"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "leadTime",
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "kind": "LinkedField",
                            "name": "variableAttributeSelections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "kind": "LinkedField",
                                "name": "variableAttribute",
                                "plural": false,
                                "selections": (v126/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "kind": "LinkedField",
                                "name": "swatch",
                                "plural": false,
                                "selections": (v126/*: any*/),
                                "storageKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPDPDesktopAggregationVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v171/*: any*/),
                      (v163/*: any*/),
                      (v193/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCondition",
                        "kind": "LinkedField",
                        "name": "condition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "state",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PdpDetail",
                        "kind": "LinkedField",
                        "name": "pdpDetailsDisplay",
                        "plural": true,
                        "selections": [
                          (v164/*: any*/),
                          (v165/*: any*/),
                          (v166/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "detailValues",
                            "plural": true,
                            "selections": [
                              (v60/*: any*/),
                              (v91/*: any*/),
                              (v51/*: any*/),
                              (v164/*: any*/),
                              (v113/*: any*/),
                              (v168/*: any*/),
                              (v167/*: any*/),
                              (v169/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v142/*: any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v143/*: any*/),
                              (v144/*: any*/),
                              (v145/*: any*/),
                              (v147/*: any*/),
                              (v148/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "kind": "LinkedField",
                                "name": "contentCreatorAttribution",
                                "plural": false,
                                "selections": [
                                  (v60/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      (v158/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v160/*: any*/),
                          (v161/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v132/*: any*/),
                      (v194/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isOnHold",
                        "storageKey": null
                      },
                      (v131/*: any*/),
                      (v110/*: any*/),
                      (v133/*: any*/),
                      (v135/*: any*/),
                      (v188/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v176/*: any*/),
                            "concreteType": "PricingGuidance",
                            "kind": "LinkedField",
                            "name": "pricingGuidance",
                            "plural": false,
                            "selections": [
                              (v129/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v137/*: any*/),
                          (v138/*: any*/)
                        ]
                      },
                      (v186/*: any*/)
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v149/*: any*/),
              (v61/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "similarLandingItems",
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "similarItemsCount"
              },
              (v93/*: any*/),
              (v62/*: any*/),
              {
                "kind": "Variable",
                "name": "mlType",
                "variableName": "mlType"
              },
              {
                "kind": "Literal",
                "name": "onlyAuctionItems",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "useML",
                "value": true
              }
            ],
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v125/*: any*/),
                      (v124/*: any*/),
                      (v51/*: any*/),
                      (v30/*: any*/),
                      (v192/*: any*/),
                      (v27/*: any*/),
                      (v112/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCreator",
                        "kind": "LinkedField",
                        "name": "creators",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Creator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v197/*: any*/),
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 1
                          }
                        ],
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v123/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": "photos(limit:1)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuctionSolution",
                        "kind": "LinkedField",
                        "name": "relevantAuctionSolution",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasReserve",
                            "storageKey": null
                          },
                          (v120/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuctionBidsConnection",
                            "kind": "LinkedField",
                            "name": "bids",
                            "plural": false,
                            "selections": (v200/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "highestBidAmount",
                            "plural": false,
                            "selections": (v178/*: any*/),
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuctionLot",
                        "kind": "LinkedField",
                        "name": "relevantAuctionLot",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "buyItNowPrice",
                            "plural": false,
                            "selections": (v178/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "openingBid",
                            "plural": false,
                            "selections": (v178/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "reservePrice",
                            "plural": false,
                            "selections": (v178/*: any*/),
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v66/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v66/*: any*/),
          {
            "condition": "isPDPDesktopAggregationVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "gdprDisplayInfo",
                    "kind": "LinkedField",
                    "name": "gdprDisplayInfo",
                    "plural": false,
                    "selections": [
                      (v201/*: any*/),
                      (v202/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "detectFeedbackLanguage",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "detectFeedbackLanguage"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
                  }
                ]
              },
              (v203/*: any*/)
            ]
          },
          {
            "condition": "fetchPdp",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "isPdpStfEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "enablePdpStf"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"enablePdpStf\")"
              },
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "fetchPdp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "gdprDisplayInfo",
                        "kind": "LinkedField",
                        "name": "gdprDisplayInfo",
                        "plural": false,
                        "selections": [
                          (v201/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "gdprDisplayInfo",
                            "kind": "LinkedField",
                            "name": "gdprDisplayInfo",
                            "plural": false,
                            "selections": [
                              (v202/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v137/*: any*/),
                      {
                        "alias": null,
                        "args": (v79/*: any*/),
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "activePromotion",
                        "plural": false,
                        "selections": (v67/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerTiers",
                            "kind": "LinkedField",
                            "name": "sellerTiers",
                            "plural": false,
                            "selections": [
                              (v73/*: any*/),
                              (v74/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dealerSince",
                            "storageKey": null
                          },
                          (v155/*: any*/),
                          (v72/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": (v154/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v176/*: any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          (v181/*: any*/),
                          (v182/*: any*/),
                          (v183/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AbTestConfigV2UserVariant",
                            "kind": "LinkedField",
                            "name": "seoAbTestV2List",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "variant",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AbTestConfigV2",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "testName",
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v62/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 10
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "personalizationId"
                  }
                ],
                "concreteType": "PersonalizedItems",
                "kind": "LinkedField",
                "name": "personalizedItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "associationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPersonalizedItem",
                    "storageKey": null
                  },
                  (v66/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v64/*: any*/),
                "concreteType": "BuyerUrgencyInfo",
                "kind": "LinkedField",
                "name": "buyerUrgencyInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalConversations",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemUrgencyInfoType",
                    "kind": "LinkedField",
                    "name": "itemUrgency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urgencyInfoType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUrgencyInfo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v62/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v79/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v154/*: any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isInteractivePdpChat",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "itemRead",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerTiers",
                                "kind": "LinkedField",
                                "name": "sellerTiers",
                                "plural": false,
                                "selections": [
                                  (v75/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v189/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "shippingAddress",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayCityStateCountry",
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PresenceResults",
                                "kind": "LinkedField",
                                "name": "presence",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "recentOnlineDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showOnlineStatus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v158/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnavailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuotes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isComplimentary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCalculated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "kind": "LinkedField",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      (v134/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "kind": "LinkedField",
                                "name": "serviceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "kind": "LinkedField",
                                    "name": "region",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "regionName",
                                        "storageKey": null
                                      },
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "buyerChatDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v88/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Item",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "presenceFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "presence"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"presence\")"
                  },
                  {
                    "alias": "readReceiptsFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "readReceipts"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"readReceipts\")"
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v68/*: any*/),
                          (v62/*: any*/)
                        ],
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "buyerItemConversation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasMessageFromSeller",
                            "storageKey": null
                          },
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasUnreadMessageForMember",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "originalBuyer",
                            "plural": false,
                            "selections": (v126/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSkuType",
                                "kind": "LinkedField",
                                "name": "sku",
                                "plural": false,
                                "selections": (v126/*: any*/),
                                "storageKey": null
                              },
                              (v66/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedback",
                                "kind": "LinkedField",
                                "name": "orderFeedback",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "token",
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "sellerMember",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              (v66/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastConversationReadDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Message",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userType",
                                    "value": "BUYER"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "translatedTextBody",
                                "storageKey": "translatedTextBody(userType:\"BUYER\")"
                              },
                              (v66/*: any*/),
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textBody",
                                "storageKey": null
                              },
                              (v204/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdDateFormatted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fromUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shipmentTrackingNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v197/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": (v154/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedNetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadePrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeNetPriceOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionAutomatedPrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionSpecialShippingRequests",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldPlaced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldReleased",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCallInitiated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomizationOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomization",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBundledOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferHoldSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionInternalAdminJoined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMarkedShipped",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclinedApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionDealerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBuyerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isApoFromCart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expirationDate",
                                    "storageKey": null
                                  },
                                  (v196/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSubmitted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRevisedByDealer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCountered",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "amountPerItem",
                                    "plural": false,
                                    "selections": (v178/*: any*/),
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "kind": "LinkedField",
                                "name": "transaction",
                                "plural": false,
                                "selections": [
                                  (v195/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Offer",
                                    "kind": "LinkedField",
                                    "name": "mostRecentOffer",
                                    "plural": false,
                                    "selections": (v126/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TransactionSummaryObject",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "offerDiscountPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": (v126/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v79/*: any*/),
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              (v156/*: any*/),
                              (v205/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v206/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Summary",
                            "kind": "LinkedField",
                            "name": "conversationSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unread",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v207/*: any*/),
                        "concreteType": "ConversationsSolrConnection",
                        "kind": "LinkedField",
                        "name": "conversationsSolr",
                        "plural": false,
                        "selections": [
                          (v199/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationsSolrEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Conversation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessage",
                                    "storageKey": null
                                  },
                                  (v204/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inboxImage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numberOfMessages",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v30/*: any*/),
                                      (v41/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ItemSkuType",
                                    "kind": "LinkedField",
                                    "name": "sku",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "skuPhotoWebPath",
                                        "args": (v89/*: any*/),
                                        "kind": "ScalarField",
                                        "name": "firstPhotoWebPath",
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessageReceivedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "hasReplied",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLatestMessageSender",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMember",
                                    "kind": "LinkedField",
                                    "name": "originalBuyer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasUnreadTag",
                                        "storageKey": null
                                      },
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*: any*/),
                                  (v60/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v208/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v209/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v207/*: any*/),
                        "filters": [
                          "page",
                          "buyerId"
                        ],
                        "handle": "connection",
                        "key": "BuyerChatVariant_conversations",
                        "kind": "LinkedHandle",
                        "name": "conversationsSolr"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isPDPDesktopAggregationVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v210/*: any*/)
            ]
          },
          (v210/*: any*/),
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v79/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v205/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v60/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "measurementUnit",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v41/*: any*/),
                  (v66/*: any*/),
                  {
                    "condition": "isPDPDesktopAggregationVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v157/*: any*/),
                      (v211/*: any*/),
                      (v206/*: any*/),
                      (v212/*: any*/),
                      {
                        "condition": "isTrade",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmType",
                            "kind": "LinkedField",
                            "name": "tradeFirm",
                            "plural": false,
                            "selections": [
                              (v213/*: any*/),
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v214/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v79/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v65/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v214/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v79/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v211/*: any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v211/*: any*/),
                      (v212/*: any*/),
                      {
                        "condition": "isTrade",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmType",
                            "kind": "LinkedField",
                            "name": "tradeFirm",
                            "plural": false,
                            "selections": [
                              (v213/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplayAndBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v211/*: any*/),
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v215/*: any*/),
                            "concreteType": "favoritesConnection",
                            "kind": "LinkedField",
                            "name": "favorites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "favoritesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Favorite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v113/*: any*/),
                                      (v66/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v60/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v208/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v209/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v215/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "SharedSaveSearchContext_favorites",
                            "kind": "LinkedHandle",
                            "name": "favorites"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isMultiSku",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds"
                  }
                ],
                "concreteType": "TransactionConnection",
                "kind": "LinkedField",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v91/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPrivateOffer",
                            "storageKey": null
                          },
                          (v195/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/545.0.0-2026-02-05T14:54:35.766Z/pdpRespMarketplacePrimaryRootQuery",
    "metadata": {},
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e0ae6f2475c2dea65a8ba1b0d5eb4772";

export default node;
